<template>
  <div class="page-wrapper label-bold nobeforered" >
    <h3 class="mb16">{{pname}}</h3>
    <Form ref="form" :rules="formRules" :model="formData" :label-width="140" label-position="left" >


      <FormItem label="结算账期">
        <span>每</span>
        <FormItem label="" class="inline-b" prop="balancePeriodType">
          <Select class="select-width"  size="small" v-model="formData.balancePeriodType" @on-change="changePeriodType"  :disabled="isRead">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in periodList" :value="item.value" :key="'keyX'+item.value">{{item.text}}</Option>
          </Select>
        </FormItem>



        <FormItem label="" class="inline-b" prop="balanceDay">
          <Select class="select-width" filterable  size="small" v-model="formData.balanceDay" :disabled="(!formData.balancePeriodType && formData.balancePeriodType!==0) || isRead">
            <!--<Option value="">请选择</Option>-->

            <Option v-for="(item,index) in weekList" :value="item.value" :key="'keyX'+index" v-if="formData.balancePeriodType===0">{{item.text}}</Option>
            <Option v-for="(item,index) in monthList" :value="item" :key="'keyXX'+item" v-if="formData.balancePeriodType===1">{{item}}</Option>
          </Select>
        </FormItem>
        <span><span v-if="formData.balancePeriodType===1">号</span>结算</span>

      </FormItem>

      <FormItem label="管理费用设置" >
        <RadioGroup v-model="formData.manageFeeType" @on-change="changeManageFee">
          <Radio v-for="item,index in typeList" :label="item.value" :key="'keyjj'+index" :disabled="item.value===1 || isRead">{{item.text}}</Radio>
        </RadioGroup>
      </FormItem>


      <FormItem label="" v-if="formData.manageFeeType===0" >
        <span>当出租率 ≥ </span>
        <FormItem label="" class="inline-b" prop="rentRate" key="m1">
          <Input  size="small" v-model="formData.rentRate"  :disabled="isRead"/>
        </FormItem>
        <span>%，管理费率为</span>
        <FormItem label="" class="inline-b" prop="manageRate" key="m2">
          <Input  size="small" v-model="formData.manageRate"  :disabled="isRead"/>
        </FormItem>
        <span>%</span>

      </FormItem>

      <FormItem label="" v-if="formData.manageFeeType===2">
        <span>不考虑出租率，管理费率统一为</span>
        <FormItem label="" class="inline-b" prop="manageRate" key="m3">
          <Input  size="small" v-model="formData.manageRate"  :disabled="isRead"/>
        </FormItem>
        <span>%</span>


      </FormItem>
      <FormItem label="结算费用项">
        <CheckboxGroup  size="small" v-model="formData.expenseItemIdsList" >
          <Checkbox label="租金" v-for="item,index in expenseItemList"
                    :key="'keycc'+index"
                    :label="item.itemCode"
                    :disabled="isRead"


          >{{item.itemName}}</Checkbox>
        </CheckboxGroup>

      </FormItem>

      <FormItem label="结算账户">
        <div class="mb16">

          <span class="name-width">开户行</span>
          <FormItem label="" class="inline-b " prop="proprietorBankName">
            <Input  size="small" class="w200" v-model="formData.proprietorBankName" :disabled="isRead"/>
          </FormItem>

        </div>
        <div class="mb16">
          <span class="name-width">开户名</span>
          <FormItem label="" class="inline-b" prop="proprietorAccountName">
            <Input  size="small" class="w200" v-model="formData.proprietorAccountName"  :disabled="isRead"/>
          </FormItem>
        </div>
        <div>
          <span class="name-width">账号</span>
          <FormItem label="" class="inline-b" prop="proprietorAccount">
            <Input  size="small" class="w200" v-model="formData.proprietorAccount"  :disabled="isRead"/>
          </FormItem>
        </div>
      </FormItem>

      <FormItem label="保证金基线" prop="baseCashDeposit2" >
        <div class="mb16">
          <Input  size="small" style="width: 265px;" v-model="formData.baseCashDeposit2"  :disabled="isRead"/>
          <span>元  （余额：{{formData.realCashDeposit!==null ?(Number(formData.realCashDeposit)/100).toFixed(2):'-'}}元）</span>
        </div>
        <div class="text-red">
          注：保证金用于支付租客提前解约产生的退款； <br>
          当项目产生收入后，优先扣足该金额的退租保证金，再执行与业主的结算； <br>
          当在此资金池产生退租支付后，系统将在下次和业主结算款项中扣除相应金额。

        </div>
      </FormItem>

    </Form>

    <div style="text-align: center;">
      <Button type="primary" :loading="loading" @click.stop="savePropBalConfig" v-if="!isRead">保存</Button>
    </div>

  </div>
</template>

<script>
  import {getPropBalConfigDetail,savePropBalConfig} from "../../../api/projectSettlemet";

  export default {
    name: "indexaaa",
    created() {

      this.isRead=this.$route.query.isRead==1?true:false
      // console.log(this.isRead)
      this.balanceConfigFid = this.$route.query.id
      this.projectFid=this.$route.query.pid
      this.pname=this.$route.query.pname
      this.getPropBalConfigDetail()


    },
    data() {
      return {
        pname:'',
        projectFid:'',
        expenseItemList:[],
        isRead:true,
        canChange:false, // for balanceDay
        canChange2:false,  //for
        balanceConfigFid:'',
        loading:false,
        monthList:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28],
        weekList:[{text:'一',value:1},{text:'二',value:2},{text:'三',value:3},{text:'四',value:4},{text:'五',value:5},{text:'六',value:6},{text:'日',value:7}],
        periodList:[{text:'周',value:0},{text:'月',value:1}],
        typeList:[{text:'标准费率',value:0},{text:'阶梯费率',value:1},{text:'无条件',value:2}],
        formData: {
          "balanceDay": '',
          "balancePeriodType": '',
          "baseCashDeposit": "",
          baseCashDeposit2:'',
          "expenseItemCodes": "",
          "manageFeeType": "",
          "projectFid": "",
          "proprietorAccount": "",
          "proprietorAccountName": "",
          manageRate:'',
          rentRate:'',
          expenseItemIdsList:[],
          proprietorBankName:'',

          // proprietorManageRateVo:{
          //   "rateFid": null,
          //   // "balanceConfigFid": "8a5891066905290a016905290a020000",
          //   "rentRate": '',
          //   "manageRate": '',
          //
          // }


        },

        formRules: {
          balancePeriodType:[
            {required: true, message: ' ', trigger: 'blur', validator: this.validateNumber}

          ],
          balanceDay:[
            {required: true, message: ' ', trigger: 'blur', validator: this.validateNumber}
          ],
          // manageFeeType:[
          //   {required: true, message: ' ', trigger: 'change', validator: this.validateNumber}
          //
          // ],
          rentRate:[
            {required: true, message: ' ', trigger: 'blur', validator: this.validateNumber2}


          ],
          manageRate:[
            {required: true, message: ' ', trigger: 'blur', validator: this.validateNumber2}
          ],
          // expenseItemIdsList:[
          //   {required: true, message: ' ', trigger: 'change', type: 'array',min: 1,}
          // ],
          proprietorBankName:[
            {required: true, message: ' ', trigger: 'blur', type: 'string'}


          ],
          proprietorAccountName:[
            {required: true, message: ' ', trigger: 'blur', type: 'string'}

          ],
          proprietorAccount:[
            {required: true, message: ' ', trigger: 'blur', type: 'string'}

          ],
          baseCashDeposit2:[
            {required: true, message: ' ', trigger: 'blur', validator: this.validateNumber2}
          ],
        },
      }
    },
    methods: {
      changeManageFee(){
        if(this.canChange2){
          this.formData.rentRate=''
          this.formData.manageRate=''

        }
        this.canChange2=true

      },
      changePeriodType(){
        if(this.canChange){
          this.formData.balanceDay='' //第一次获取formData时不触发变化
        }
        this.canChange=true
      },
      getPropBalConfigDetail(){
        if(!this.balanceConfigFid && !this.projectFid){
          return
        }
        let params={balanceConfigFid:this.balanceConfigFid,projectFid:this.projectFid}
        getPropBalConfigDetail(params).then(res=>{
          if(!res.data){
            return
          }
          this.expenseItemList=res.data.expenseItemList
          res.data['expenseItemIdsList']=[]
          res.data.expenseItemCodes &&   (res.data['expenseItemIdsList']=res.data.expenseItemCodes.split(','))
          res.data['rentRate']=''
          res.data['manageRate']=''
          res.data.proprietorManageRateVo  && res.data.proprietorManageRateVo.rentRate!==null && ( res.data['rentRate']=res.data.proprietorManageRateVo.rentRate)
          res.data.proprietorManageRateVo &&  res.data.proprietorManageRateVo.manageRate!==null && (res.data['manageRate']=res.data.proprietorManageRateVo.manageRate)
          res.data.baseCashDeposit!==null  && (res.data['baseCashDeposit2']=res.data.baseCashDeposit/100)

          this.formData=res.data

        }).catch(error=>{

        })

      },
      savePropBalConfig(){


        if(!this.formData.manageFeeType && this.formData.manageFeeType!==0){
          this.$Message.info('请选择管理费用设置')
          return
        }
        if(this.formData.expenseItemIdsList.length===0){
           this.$Message.info('请选择结算费用项')
          return
        }
        this.$refs['form'].validate(bool=>{
          if(bool){
            this.loading=true
            this.formData.expenseItemCodes=this.formData.expenseItemIdsList.join(',')
            if(  this.formData['proprietorManageRateVo']===null){
              this.formData['proprietorManageRateVo']={}
            }
            this.formData['proprietorManageRateVo']['rentRate']=this.formData.rentRate
            this.formData['proprietorManageRateVo']['manageRate']=this.formData.manageRate
            this.formData['baseCashDeposit']=Number(this.formData['baseCashDeposit2'])*100

            savePropBalConfig(this.formData).then(res=>{
              this.$Message.success('修改成功')
              // this.$router.push({ name: 'projectsettlement'})
              this.$router.push({ name: 'projects',params:{targetTab:'6'}})
            }).catch(error=>{

            }).finally(()=>{
              this.loading=false

            })
          }
          else {

          }

        })


      },
      validateNumber2(rule, value, callback) {
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },

    },

  }
</script>
<style scoped>
  *{
    vertical-align: middle;
    /*line-height: 30px;*/
  }
  span{
    line-height: 22px;
  }
  .name-width{
    display: inline-block;
    width: 60px;

  }
  .inline-b{
    width: 80px;
  }
  .w200{
    width: 200px;
  }
  .ivu-form-item-required .ivu-form-item-label:before{
    display: none;
  }


</style>
